import { useMutation } from '@tanstack/react-query';

import { RemovePageData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removePage = (params: RemovePageData): Promise<void> => {
  const { platform, ...restParams } = params;
  return axios.delete(`/${PLATFORM_URL_SEGMENT[platform]}/pages`, { params: restParams });
};

type UseRemovePageOptions = {
  config?: MutationConfig<typeof removePage>;
};

export function useRemovePage({ config = {} }: UseRemovePageOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: removePage,
  });
}
